import { AboboCrypto } from '@utils/aboboCrypto';
import { useClient } from '@utils/api';
import { Client } from '@utils/api/aboboApiTypes';
import { createContext, useContext, useEffect, useState } from 'react';

// Define the context type
interface ApplicationContextType {
  client: Client | undefined;
  clientPublicKey: CryptoKey | null;
}

// Create the context
export const ApplicationContext = createContext<ApplicationContextType | null>(
  null
);

// Create the provider component
export const ApplicationProvider = ({ children }) => {
  const [clientPublicKey, setClientPublicKey] = useState<CryptoKey | null>(
    null
  );
  const { client } = useClient();

  useEffect(() => {
    if (!client) return;

    AboboCrypto.importPublicKey(client.publicKey).then((key) =>
      setClientPublicKey(key)
    );
  }, [client]);

  return (
    <ApplicationContext.Provider
      value={{
        client,
        clientPublicKey,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplicationContext = () => {
  const context = useContext(ApplicationContext);
  if (!context) {
    throw new Error(
      'useApplicationContext must be used within a ApplicationContextProvider'
    );
  }

  return context;
};
